import 'react-simple-keyboard/build/css/index.css';

import { type MutableRefObject, useContext, useEffect, useState } from 'react';
import Keyboard from 'react-simple-keyboard';

import { AppContext } from '../../context/app';
import { useKioskManager } from '../../hooks/useKioskManager';
import styles from './kioskKeyboard.module.scss';

interface KioskKeyboardProps {
  keyboardRef: MutableRefObject<any>;
}

export function KioskKeyboard({ keyboardRef }: KioskKeyboardProps) {
  const { setGlobalSearchText, globalSearchText } = useContext(AppContext);
  const { kiosk, kioskMode } = useKioskManager();
  const [layoutName, setLayoutName] = useState<string>('default');

  useEffect(() => {
    if (typeof globalSearchText === 'undefined') {
      // Set keyboard input to an empty string to clear it
      keyboardRef.current?.setInput('');
    } else {
      // Update the keyboard with the new value of globalSearchText
      keyboardRef.current?.setInput(globalSearchText || '');
    }
  }, [globalSearchText, keyboardRef]);

  const handleShift = () => {
    setLayoutName(layoutName === 'default' ? 'shift' : 'default');
  };

  const onKeyPress = (button: string) => {
    if (button === '{shift}' || button === '{lock}') handleShift();
  };

  const handleChange = (input: string, e?: MouseEvent | undefined) => {
    setGlobalSearchText(input);
  };

  return (
    <div
      className={`${styles.keyboardContainer} ${
        kiosk && kioskMode && styles[kiosk.model]
      }`}
    >
      <Keyboard
        keyboardRef={(r) => (keyboardRef.current = r)}
        layoutName={layoutName}
        onChange={handleChange}
        onKeyPress={onKeyPress}
      />
    </div>
  );
}
